import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visible", "text", "icon", "autoDismiss", "action", "onClose"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Toast/Toast.js",
  _this = this;
import React, { useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import getRandomId from '../../core/utils/getRandomId';
import { testIdProps } from '../../helpers';
import { Transition } from 'react-transition-group';
import { Sliding, SLIDING_DURATION } from './animation';
import { Row } from '../..';
import Column from '../Column';
import { AnimationWrapper, NoPaddingGrid, ToastComponent, IconWrapper, Title, Action } from './styles';
import { useWindowSize } from '../../core/hooks/windowSize';
var Toast = function Toast(_ref) {
  var visible = _ref.visible,
    text = _ref.text,
    Icon = _ref.icon,
    _ref$autoDismiss = _ref.autoDismiss,
    autoDismiss = _ref$autoDismiss === void 0 ? true : _ref$autoDismiss,
    action = _ref.action,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var windowSize = useWindowSize();
  var toastRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    exited = _useState4[0],
    setExited = _useState4[1];
  if (typeof document === 'undefined') {
    return null;
  }
  var body = document.getElementsByTagName('body')[0];
  var toastNode = useMemo(function () {
    var node = document.querySelector('[id^="toast-root-"]');
    if (!node && visible) {
      node = document.createElement('div');
      node.setAttribute('id', "toast-root-".concat(getRandomId()));
      node.setAttribute('style', 'position:fixed;left:0;top:0;width:100%;height:100%,pointer-event:none');
      body.appendChild(node);
    }
    return node;
  }, [visible]);
  if (!visible && exited) return null;
  var toastElement = /*#__PURE__*/React.createElement(AnimationWrapper, {
    zIndex: 1000,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Transition, {
    timeout: SLIDING_DURATION,
    appear: true,
    "in": visible,
    onEnter: function onEnter() {
      setExited(false);
      autoDismiss && setTimer(setTimeout(function () {
        onClose && onClose();
      }, 5000));
    },
    onExited: function onExited() {
      setExited(true);
      timer && clearTimeout(timer);
      setTimer(null);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(NoPaddingGrid, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Row, {
      center: "xs",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Column, {
      xs: 12,
      sm: 8,
      md: 8,
      noGutter: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Sliding, {
      state: state,
      windowHeight: windowSize.height,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(ToastComponent, _extends({}, testIdProps(rest), {
      ref: toastRef,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 19
      }
    }), Icon && /*#__PURE__*/React.createElement(IconWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 23
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      size: 24,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 25
      }
    })), text && /*#__PURE__*/React.createElement(Title, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 30
      }
    }, text), action && /*#__PURE__*/React.createElement(Action, {
      "data-testid": "toast-action-id",
      onClick: action.onPress,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 23
      }
    }, action.text))))));
  }));
  return /*#__PURE__*/createPortal(toastElement, toastNode);
};
export default Toast;